module.exports = __webpack_public_path__ + "img/cardBrands.c4a2425a.png";